var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "advance",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.673,
    height: 98,
    viewBox: "0 0 101.673 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.272,
    y1: 0.885,
    x2: 0.98,
    y2: 0.152,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff2ed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#ffe9dd",
    stopOpacity: 0.373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#ffd5ba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2040",
    "data-name": "Group 2040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M45.016,10.756C22.824,16.846,22,62.1,4.023,77.412c-8.845,7.533-1.033,18.2,3.751,19.72,8.916,2.825,12.052-3.139,17.821-4.9,8.428-2.55,15.013,5.8,19.649,8.474,21.191,12.2,56.39,7.364,56.43-14.723-.738-8.575-6.968-15.731-12.047-22.317C76.036,48.477,78.975,47.125,84.581,29.9,87.21,10.4,59.613,6.612,45.016,10.756Z",
    transform: "translate(-0.001 -9.25)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079",
    transform: "translate(3.661 9.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078",
    transform: "translate(3.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M121.969,105.215q-1.907-.017-3.763.038V98.238a1.107,1.107,0,0,0-1.09-1.106c-2.594-.047-5.113.029-7.528.192L113.3,82.981a.6.6,0,0,0-.726-.726L84,89.643a.6.6,0,0,0-.272,1l7.3,7.3.6,2.31a71.6,71.6,0,0,0-7.652,2.378,94.819,94.819,0,0,0-33.14-5.5,1.107,1.107,0,0,0-1.09,1.106v7.015q-1.855-.053-3.763-.038a2.214,2.214,0,0,0-2.2,2.211v20.692a19.043,19.043,0,1,0,28.884,24.158c3.177.753,5.8,1.516,7.714,2.124v.856a2.21,2.21,0,0,0,2.21,2.21h2.772a2.21,2.21,0,0,0,2.21-2.21V154.4a114.114,114.114,0,0,1,34.376-5.225,2.207,2.207,0,0,0,2.221-2.209v-39.54a2.214,2.214,0,0,0-2.2-2.211Z",
    transform: "translate(-37.345 -77.464)",
    fill: "#0000cb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061",
    transform: "translate(6.446 14.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2060",
    "data-name": "Group 2060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2059",
    "data-name": "Group 2059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2044",
    "data-name": "Group 2044",
    transform: "translate(0 8.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M69.767,176.183v39.6a2.21,2.21,0,0,0,2.225,2.213,111.465,111.465,0,0,1,38.025,6.478V180.447a111.467,111.467,0,0,0-38.046-6.478A2.217,2.217,0,0,0,69.767,176.183Z",
    transform: "translate(-69.767 -173.965)",
    fill: "#9393ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M99.8,214.65a1.1,1.1,0,0,0,1.121,1.106,94.935,94.935,0,0,1,33.157,5.507V180.616a111.17,111.17,0,0,0-34.279-6.44V214.65Z",
    transform: "translate(-93.826 -174.134)",
    fill: "#8282ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M312.461,176.183v39.6a2.21,2.21,0,0,1-2.225,2.213,111.465,111.465,0,0,0-38.025,6.478V180.447a111.467,111.467,0,0,1,38.046-6.478A2.218,2.218,0,0,1,312.461,176.183Z",
    transform: "translate(-232.083 -173.965)",
    fill: "#6c6cff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041",
    transform: "translate(40.129 0.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M305.369,215.756a1.1,1.1,0,0,0,1.122-1.106V174.176a111.169,111.169,0,0,0-34.279,6.44v40.647A94.935,94.935,0,0,1,305.369,215.756Z",
    transform: "translate(-272.212 -174.176)",
    fill: "#4d4dff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043",
    transform: "translate(36.588 38.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M261.3,368.407v11.461a2.213,2.213,0,0,1-2.213,2.213h-2.775a2.213,2.213,0,0,1-2.213-2.213V368.407Z",
    transform: "translate(-254.099 -368.407)",
    fill: "#fa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M261.3,368.407v7.24c-2.3.715-3.6,1.231-3.6,1.231s-1.3-.516-3.6-1.231v-7.24Z",
    transform: "translate(-254.099 -368.407)",
    fill: "#ff9c33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046",
    transform: "translate(5.97 5.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M99.8,160.752v38.683a1.1,1.1,0,0,0,1.121,1.106,94.935,94.935,0,0,1,33.157,5.507V166.231A94.906,94.906,0,0,0,99.8,160.752Z",
    transform: "translate(-99.797 -160.711)",
    fill: "#ffd8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M306.491,160.752v38.683a1.1,1.1,0,0,1-1.121,1.106,94.935,94.935,0,0,0-33.157,5.507V166.231A94.908,94.908,0,0,1,306.491,160.752Z",
    transform: "translate(-238.054 -160.711)",
    fill: "#ffb2b2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2058",
    "data-name": "Group 2058",
    transform: "translate(5.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2057",
    "data-name": "Group 2057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M269.092,233.31a8.026,8.026,0,0,1,.62-1.04v1.113C269.508,233.358,269.3,233.332,269.092,233.31Z",
    transform: "translate(-235.434 -212.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M265.527,247.23q.647.063,1.257.149v5.408A8.281,8.281,0,0,1,265.527,247.23Z",
    transform: "translate(-232.505 -224.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M100.894,133.215a1.108,1.108,0,0,0-1.091,1.107v38.735a94.906,94.906,0,0,1,34.278,5.481V138.722a94.945,94.945,0,0,0-33.186-5.507Z",
    transform: "translate(-99.802 -133.201)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M194.931,220.02a8.022,8.022,0,0,0-.62,1.04c.209.022.416.048.62.074v2.01q-.608-.086-1.257-.149a8.281,8.281,0,0,0,1.257,5.557v3.416c-.165-.179-.318-.362-.461-.549-2.247-2.939-3.183-5.807-2.791-8.537-7.706.018-14.146,6.631-14.213,6.7a.993.993,0,0,1-1.435-1.374c.3-.316,7.372-7.595,16.178-7.307a11.243,11.243,0,0,1,2.724-3.921Z",
    transform: "translate(-160.69 -200.323)",
    fill: "#ffeded"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2048",
    "data-name": "Group 2048",
    transform: "translate(5.558 5.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M151.34,164.906a98.654,98.654,0,0,0-22.422-3.7,1.109,1.109,0,0,0-1.161,1.106V175.2a1.1,1.1,0,0,0,1.054,1.105,98.648,98.648,0,0,1,21.928,3.532,1.105,1.105,0,0,0,1.4-1.066v-12.8a1.108,1.108,0,0,0-.8-1.064Z",
    transform: "translate(-127.757 -161.207)",
    fill: "#fa6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M216.556,239.738a16.312,16.312,0,0,1,4.07-.886v-2a19.769,19.769,0,0,0-7.391,2.119c1.181.252,2.29.51,3.321.767Z",
    transform: "translate(-190.727 -216.245)",
    fill: "#ff9c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M306.49,134.322v38.735a94.906,94.906,0,0,0-34.278,5.481V138.722a94.944,94.944,0,0,1,33.186-5.507A1.108,1.108,0,0,1,306.49,134.322Z",
    transform: "translate(-238.055 -133.201)",
    fill: "#ffeded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M320.311,133.86l-4.937,19.1a.6.6,0,0,1-1,.272l-7.312-7.312-4.891-1.27a.593.593,0,0,1-.427-.427l-1.27-4.891-1.8-1.8A98.7,98.7,0,0,1,320.311,133.86Z",
    transform: "translate(-259.254 -133.729)",
    fill: "#ffd8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M282.292,215.014a6.435,6.435,0,0,0-3.426-4.394,17.816,17.816,0,0,0-6.654-2.012v2.01c4.718.664,7.7,2.376,8.124,4.748a3.781,3.781,0,0,1-2.27,3.958c-1.658.73-3.382.131-4.736-1.638a15.786,15.786,0,0,1-1.117-1.66v3.416a6.194,6.194,0,0,0,4.477,2.177,5.378,5.378,0,0,0,2.177-.475,5.738,5.738,0,0,0,3.426-6.13Zm-4.869-11.764a.994.994,0,1,0-.8-1.819,16.8,16.8,0,0,0-4.41,3.024v3.04A14.281,14.281,0,0,1,277.423,203.25Z",
    transform: "translate(-238.005 -187.798)",
    fill: "#ffd8d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2056",
    "data-name": "Group 2056",
    transform: "translate(38.824 9.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049",
    transform: "translate(0 22.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M296.679,299.737a.994.994,0,0,1-.271-1.951,99.677,99.677,0,0,1,22.344-3.655.994.994,0,0,1,.09,1.986,97.664,97.664,0,0,0-21.891,3.581A1,1,0,0,1,296.679,299.737Z",
    transform: "translate(-295.685 -294.131)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2055",
    "data-name": "Group 2055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050",
    transform: "translate(0 18.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M296.679,277.784a.994.994,0,0,1-.271-1.951,99.674,99.674,0,0,1,22.344-3.655.994.994,0,1,1,.09,1.986,97.663,97.663,0,0,0-21.891,3.581A.994.994,0,0,1,296.679,277.784Z",
    transform: "translate(-295.685 -272.177)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2051",
    "data-name": "Group 2051",
    transform: "translate(0 13.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M296.679,255.833a.994.994,0,0,1-.271-1.951,99.675,99.675,0,0,1,22.344-3.655.994.994,0,1,1,.09,1.986,97.663,97.663,0,0,0-21.891,3.581A.994.994,0,0,1,296.679,255.833Z",
    transform: "translate(-295.685 -250.227)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052",
    transform: "translate(0 9.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M296.679,233.881a.994.994,0,0,1-.271-1.951,99.676,99.676,0,0,1,22.344-3.655.994.994,0,1,1,.09,1.986,97.661,97.661,0,0,0-21.891,3.581A.994.994,0,0,1,296.679,233.881Z",
    transform: "translate(-295.685 -228.274)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M322.611,206.323a99.67,99.67,0,0,0-21.376,3.385.994.994,0,0,0,.52,1.919,97.672,97.672,0,0,1,20.9-3.316,1.027,1.027,0,0,0,.995-.938.993.993,0,0,0-1.038-1.05Z",
    transform: "translate(-299.544 -201.162)",
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M364.164,207.97l-.531,2.052c-1.278.131-2.521.286-3.722.457l-1.75-1.75C360.057,208.431,362.065,208.171,364.164,207.97Z",
    transform: "translate(-345.741 -202.483)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    transform: "translate(16.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M381.77,182.742a.994.994,0,0,1-.1-1.983c1.757-.179,3.525-.309,5.256-.388a.994.994,0,0,1,.09,1.986c-1.693.077-3.424.2-5.144.38A.987.987,0,0,1,381.77,182.742Z",
    transform: "translate(-380.777 -180.37)",
    fill: "#fa6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054",
    transform: "translate(16.917 0.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M383.648,181.42l-.529,2.04c-.415.038-.833.078-1.249.119-.034,0-.068,0-.1,0a.994.994,0,0,1-.1-1.982Q382.66,181.5,383.648,181.42Z",
    transform: "translate(-380.776 -181.42)",
    fill: "#ff9c33"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2072",
    "data-name": "Group 2072",
    transform: "translate(0 41.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 19.07,
    cy: 19.07,
    rx: 19.07,
    ry: 19.07,
    fill: "#ffc498"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 16.341,
    cy: 16.341,
    rx: 16.341,
    ry: 16.341,
    transform: "translate(2.728 2.728)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2064",
    "data-name": "Group 2064",
    transform: "translate(19.529 19.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M141.88,370.12a.994.994,0,0,1-1.73.618l-4.325-4.775a.994.994,0,0,1,1.474-1.335l4.325,4.775A.992.992,0,0,1,141.88,370.12Z",
    transform: "translate(-135.568 -364.303)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2065",
    "data-name": "Group 2065",
    transform: "translate(8.312 8.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M80.848,307.417l8.411,8.411a.994.994,0,1,1-1.406,1.406l-8.411-8.411a.994.994,0,0,1,1.406-1.406Z",
    transform: "translate(-79.151 -307.126)",
    fill: "#6c6cff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(16.162 4.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2067",
    "data-name": "Group 2067",
    transform: "translate(0 11.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2066",
    "data-name": "Group 2066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M121.542,352.426a2.908,2.908,0,1,1,2.908-2.908A2.911,2.911,0,0,1,121.542,352.426Zm0-3.827a.919.919,0,1,0,.92.919A.92.92,0,0,0,121.542,348.6Z",
    transform: "translate(-118.635 -346.611)",
    fill: "#9393ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070",
    transform: "translate(0.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2068",
    "data-name": "Group 2068",
    transform: "translate(1.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M129.253,302.389a.994.994,0,0,1-.994-.994V289.927a.994.994,0,0,1,1.988,0v11.467A.994.994,0,0,1,129.253,302.389Z",
    transform: "translate(-128.259 -288.933)",
    fill: "#9393ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069",
    transform: "translate(0 1.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M125.834,295.955h-2.258a.994.994,0,0,1,0-1.988h2.258a.994.994,0,0,1,0,1.988Z",
    transform: "translate(-122.582 -293.967)",
    fill: "#b2b2ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2073",
    "data-name": "Group 2073",
    transform: "translate(46.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M299.124,58.255l-28.615,7.4a.6.6,0,0,0-.272,1l7.314,7.314,1.27,4.891a.6.6,0,0,0,.427.427l4.891,1.27,7.314,7.314a.6.6,0,0,0,1-.272l7.4-28.615A.6.6,0,0,0,299.124,58.255Z",
    transform: "translate(-270.062 -58.235)",
    fill: "#fa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M307.731,74.529,329.725,58.96a.117.117,0,0,1,.163.163L314.319,81.117l-4.891-1.27A.6.6,0,0,1,309,79.42Z",
    transform: "translate(-300.242 -58.798)",
    fill: "#ff8a00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2077",
    "data-name": "Group 2077",
    transform: "translate(51.286 37.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    transform: "translate(0 7.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M300.773,284.88a5.891,5.891,0,0,1-1.982,2.541c-.652.171-1.264.34-1.841.5a.995.995,0,0,1-1.229-.686.988.988,0,0,1,.06-.7,3.508,3.508,0,0,0,1.09-.29,3.869,3.869,0,0,0,1-.642c.9-.239,1.867-.485,2.9-.728Z",
    transform: "translate(-295.683 -284.88)",
    fill: "#ff4d4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075",
    transform: "translate(2.96 3.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M313.091,265q-1.035.245-1.976.487a3.083,3.083,0,0,0-.046-.662,3.462,3.462,0,0,0-.5-1.253q.948-.245,1.994-.493a5.243,5.243,0,0,1,.459,1.394A4.776,4.776,0,0,1,313.091,265Z",
    transform: "translate(-310.572 -263.08)",
    fill: "#ff4d4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M299.138,247.411q-1.172.3-2.189.592a1,1,0,0,1-.272.038.482.482,0,0,1-.076,0,7.628,7.628,0,0,0-.686-.348s0,0,0,0a1.035,1.035,0,0,1-.191-.366,1,1,0,0,1,.686-1.229l.5-.141q.4.194.763.406A8.926,8.926,0,0,1,299.138,247.411Z",
    transform: "translate(-295.682 -245.95)",
    fill: "#ff4d4d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M21.5,259.8a.99.99,0,0,1-.7-.291l-2.088-2.088a.994.994,0,0,1,0-1.406l2.088-2.088a.994.994,0,0,1,1.406,0l2.088,2.088a.994.994,0,0,1,0,1.406L22.2,259.507A.991.991,0,0,1,21.5,259.8Zm-.682-3.082.682.682.682-.682-.682-.682Z",
    transform: "translate(-18.414 -214.844)",
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M450.65,101.366a.99.99,0,0,1-.7-.291l-2.088-2.088a.994.994,0,0,1,0-1.406l2.088-2.088a.994.994,0,0,1,1.406,0l2.088,2.088a.994.994,0,0,1,0,1.406l-2.088,2.088A.99.99,0,0,1,450.65,101.366Zm-.682-3.082.682.682.682-.682-.682-.682Z",
    transform: "translate(-362.366 -87.853)",
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M330.7,451.928a.99.99,0,0,1-.7-.291l-2.088-2.088a.994.994,0,0,1,0-1.406L330,446.055a.994.994,0,0,1,1.406,0l2.088,2.088a.994.994,0,0,1,0,1.406l-2.088,2.088A.991.991,0,0,1,330.7,451.928Zm-.682-3.082.682.682.682-.682-.682-.682Z",
    transform: "translate(-266.234 -368.833)",
    fill: "#ff9c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M187.763,81.164a.99.99,0,0,1-.7-.291l-2.088-2.088a.994.994,0,0,1,0-1.406l2.088-2.088a.994.994,0,0,1,1.406,0l2.088,2.088a.994.994,0,0,1,0,1.406l-2.088,2.088A.99.99,0,0,1,187.763,81.164Zm-.682-3.082.682.682.682-.682-.682-.682Z",
    transform: "translate(-151.671 -71.667)",
    fill: "#8282ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M222.816,110.614a.994.994,0,0,1-.7-1.7l1.988-1.988a.994.994,0,0,1,1.406,1.406l-1.988,1.988A.991.991,0,0,1,222.816,110.614Z",
    transform: "translate(-181.437 -97.014)",
    fill: "#ff9c33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080",
    transform: "translate(6.43 8.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M117.971,76.213c-.936-.008-1.86,0-2.778.019v-6a2.111,2.111,0,0,0-2.066-2.1c-2.138-.039-4.221.012-6.246.122l3.37-13.033a1.588,1.588,0,0,0-1.935-1.935L79.739,60.672a1.588,1.588,0,0,0-.726,2.661l7.113,7.113.286,1.1c-3.324.9-5.6,1.7-6.446,2.012a97.549,97.549,0,0,0-33.159-5.43,2.111,2.111,0,0,0-2.066,2.1v6c-.918-.017-1.843-.027-2.778-.018a3.217,3.217,0,0,0-3.184,3.2V99.682A20.028,20.028,0,1,0,69.1,125.409c2.489.605,4.61,1.208,6.28,1.722v.12a3.207,3.207,0,0,0,3.2,3.2h2.771a3.207,3.207,0,0,0,3.2-3.2v-7.89a96.649,96.649,0,0,1,28.506-4.024,2.1,2.1,0,0,0,2.13-2.1V78.216c.633-.012,1.268-.021,1.909-.021.283,0,.567,0,.851,0a1.226,1.226,0,0,1,1.216,1.218v39.542a1.212,1.212,0,0,1-.361.866,1.2,1.2,0,0,1-.859.35A114.986,114.986,0,0,0,88.9,123.833a.993.993,0,1,0,.495,1.923,113.137,113.137,0,0,1,28.534-3.594h.028a3.2,3.2,0,0,0,3.195-3.2V79.417a3.217,3.217,0,0,0-3.184-3.2ZM80.909,62.42l27.251-7.045-7.046,27.248L94.3,75.812a1,1,0,0,0-.452-.259L89.19,74.344l-1.21-4.658a.994.994,0,0,0-.259-.452Zm-28.53,70.01a18.05,18.05,0,1,1,18.051-18.05,18.071,18.071,0,0,1-18.051,18.05Zm17.772-8.806a19.89,19.89,0,0,0,1.857-5.214c1.262.327,2.393.647,3.371.941v5.705C73.914,124.616,72.156,124.124,70.151,123.625Zm12.42,3.625a1.219,1.219,0,0,1-1.218,1.218H78.582a1.219,1.219,0,0,1-1.218-1.218v-7.274c1.427.471,2.221.783,2.237.789a.994.994,0,0,0,.732,0c.033-.013.824-.321,2.237-.785v7.269Zm30.637-14.011a.112.112,0,0,1-.034.081.1.1,0,0,1-.076.031,97.532,97.532,0,0,0-33.128,5.43,77.863,77.863,0,0,0-7.66-2.343A20.043,20.043,0,0,0,52.379,94.346a19.927,19.927,0,0,0-11.613,3.718V79.417A1.226,1.226,0,0,1,41.981,78.2c.93-.008,1.848,0,2.761.02V90.71a.993.993,0,0,0,1.985,0V70.228a.115.115,0,0,1,.116-.113A94.84,94.84,0,0,1,79.6,75.544a1,1,0,0,0,.732,0c.059-.023,2.5-.975,6.578-2.076l.415,1.6a1.589,1.589,0,0,0,1.138,1.138l4.623,1.2,7.113,7.112a1.588,1.588,0,0,0,2.661-.725l3.5-13.53c2.172-.132,4.422-.19,6.731-.149a.115.115,0,0,1,.116.113v43.011Z",
    transform: "translate(-32.342 -53.233)",
    fill: "#0000cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M201.587,186.622a18.476,18.476,0,0,0-7.274-2.086c1.694-3.408,5.771-5.257,5.832-5.284a.994.994,0,0,0-.8-1.819c-.232.1-5.34,2.4-7.134,6.943-8.806-.283-15.876,6.991-16.177,7.306a.994.994,0,0,0,1.436,1.375c.067-.069,6.507-6.682,14.213-6.7-.391,2.731.545,5.6,2.791,8.538a6.439,6.439,0,0,0,4.938,2.726,5.364,5.364,0,0,0,2.178-.476,5.736,5.736,0,0,0,3.426-6.128A6.434,6.434,0,0,0,201.587,186.622Zm-.8,8.7c-1.656.729-3.381.132-4.734-1.638-1.952-2.555-2.75-4.98-2.375-7.216,5.443.523,8.918,2.32,9.381,4.9A3.781,3.781,0,0,1,200.786,195.325Z",
    transform: "translate(-147.3 -152.719)",
    fill: "#0000cb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvance);
export default __webpack_public_path__ + "static/media/advance.686d5fd25668c3077a51947a7caf208d.svg";
export { ForwardRef as ReactComponent };